import Navbar from "../Components/Navbar";
import ContactFooter from "../Components/ContactFooter";

export function Homescreen() {
  return (
    <>
      <Navbar/>

      <div className="high-tea-grid">
        <div className="white-text-block">
          <h1 className="header-1">High Teas To Go</h1>
          <p>
            Genieten van een complete High Tea, gewoon bij jou thuis of op locatie!<br></br><br></br>
            Wil je iemand verrassen, heb je iets te vieren of heb je gewoon zin in een heerlijke middag vol lekkers?
            Wij verzorgen een ambachtelijke High Tea, vers voor jou bereid en bezorgd waar je maar wilt.
            Van luxe zoete gebakjes en verse scones met clotted cream tot hartige sandwiches en verschillende
            theesoorten, wij regelen alles tot in de puntjes.<br></br><br></br>
            Met liefde gemaakt van de beste ingrediënten.<br></br><br></br>
            Geen stress in de keuken, je hoeft alleen maar de tafel te dekken en water te koken.<br></br><br></br>
            Voor elke gelegenheid, perfect voor verjaardagen, baby showers of vriendinnenmiddagen.<br></br><br></br>
            Of je nu intiem wilt theeleuten in de woonkamer of een grote groep wilt verwennen op een feestlocatie,
            wij maken er een onvergetelijk én smakelijk moment van.
          </p>
        </div>

        <img className="picture-container" src={require("../Images/IMG-20240220-WA0009.jpg")} alt=""/>
      </div>

      <ContactFooter/>
    </>
  );
}

export default Homescreen;